<template>
  <span
    v-if="display"
    class="copyable"
    :title="'点击复制' + (label ? ' ' + label : '')"
    @click.stop="onCopy"
  >{{ display }}</span>
  <span v-else class="muted">—</span>
</template>
<script>
import { copyText } from '../utils/copy'

export default {
  name: 'CopyText',
  props: {
    text: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
  },
  computed: {
    display() {
      return String(this.text || '').trim()
    },
  },
  methods: {
    onCopy() {
      copyText(this.display, this.label)
    },
  },
}
</script>
<style scoped>
.copyable {
  cursor: pointer;
  color: #409eff;
  word-break: break-all;
}
.copyable:hover {
  text-decoration: underline;
}
.muted {
  color: #c0c4cc;
}
</style>
